import React, { useEffect, useState } from "react";

import "../Map.css";
import { Link, useOutletContext } from "react-router-dom";
import "../MapMenu.css";
import { loadStudentMenuI18n } from "../../../../i18n/loaders/studentMenu.i18n";
import { useTranslation } from "react-i18next";
import { useAuthStudent } from "../../../../context/StudentLoginContext/StudentAuthContext";
import { useAuth } from "../../../../context/LoginContext/AuthContext";
import { AuthModal } from "../../../../common/AuthV2/AuthModal";
import NavigateToAddStudentPopup from "../../../../common/AuthV2/NavigateToAddStudentPopup";

export const MapMenuStatic = () => {
  const { t } = useTranslation("common");
  const { user } = useAuth();
  const { student } = useAuthStudent();
  const currentUser = user?.user || student?.student;
  const [showAuthModal, setShowAuthModal] = useState(false);
  const [showAddStudentModal, setShowAddStudentModal] = useState(false);
  const [authModalView, setAuthModalView] = useState("options");
  const { userType } = useOutletContext();

  const isSubscribed = Boolean(
    currentUser?.subscription_data?.is_subscribed || currentUser?.is_subscribed,
  );

  // load namespace once
  useEffect(() => {
    loadStudentMenuI18n();
  }, []);

  const handleLockedClick = (e) => {
    // Not logged in
    if (!currentUser) {
      e.preventDefault();
      setAuthModalView("options"); // or "login"
      setShowAuthModal(true);
      return;
    }

    // Logged in but not subscribed
    if (!isSubscribed) {
      e.preventDefault();
      setShowAddStudentModal(true);
      return;
    }

    // ✅ Subscribed → allow navigation
  };

  return (
    <>
      <div className={`studntMapMenu `}>
        <Link className="studntFtrNavLink" to="/student/start-your-quest">
          <div className="logoWrapper mb-3">
            <div className="logoContainer">
              <img
                className="logoOuter"
                src="https://d2lvj32mp5x83n.cloudfront.net/static/studentadmin/footer/background/home.png"
                alt=""
              />
              <img
                className="logoInner"
                src="https://d2lvj32mp5x83n.cloudfront.net/static/studentadmin/footer/logo/homeLogo.png"
                alt=""
              />
            </div>
            <p className="mb-0 labelIcon">{t("menu.home")}</p>
          </div>
        </Link>
        {userType === "school-student" ? (
          <Link to="/student/admin/quests" className="studntFtrNavLink">
            <div className="logoWrapper mb-3">
              <div className="logoContainer">
                <img
                  className={`logoOuter`}
                  src="https://d2lvj32mp5x83n.cloudfront.net/static/studentadmin/footer/background/quest.png"
                  alt=""
                />
                <img
                  className={`logoInner`}
                  src="https://d2lvj32mp5x83n.cloudfront.net/static/studentadmin/footer/logo/questLogo.png"
                  alt="quest"
                />
              </div>
              <p className="mb-0 labelIcon">{t("menu.quests")}</p>
            </div>
          </Link>
        ) : (
          <Link
            to="/student/admin/quests"
            className="studntFtrNavLink"
            onClick={handleLockedClick}
          >
            <div className="logoWrapper mb-3">
              <div className="logoContainer">
                <img
                  className={`logoOuter ${!isSubscribed ? "blackgrayscale" : ""}`}
                  src="https://d2lvj32mp5x83n.cloudfront.net/static/studentadmin/footer/background/quest.png"
                  alt=""
                />
                <img
                  className={`logoInner ${!isSubscribed ? "blackgrayscale" : ""}`}
                  src="https://d2lvj32mp5x83n.cloudfront.net/static/studentadmin/footer/logo/questLogo.png"
                  alt="quest"
                />
                {!isSubscribed && (
                  <img
                    className="CommonMenuLock"
                    src="https://d2lvj32mp5x83n.cloudfront.net/static/webMap/crown.png"
                    alt=""
                  />
                )}
              </div>
              <p className="mb-0 labelIcon">{t("menu.quests")}</p>
            </div>
          </Link>
        )}

        <Link to={`/student/festival`} className="studntFtrNavLink">
          <div className="logoWrapper mb-3">
            <div className="logoContainer">
              <img
                className="logoOuter"
                src="https://d2lvj32mp5x83n.cloudfront.net/static/studentadmin/footer/background/festival.png"
                alt=""
              />
              <img
                className="logoInner"
                src="https://d2lvj32mp5x83n.cloudfront.net/static/studentadmin/footer/logo/festivalLogo.png"
                alt="certificate"
              />
            </div>
            <p className="mb-0 labelIcon">{t("menu.festivals")}</p>
          </div>
        </Link>

        {userType === "school-student" ? (
          <Link
            to={`/student/admin/certificate-trophy`}
            className="studntFtrNavLink"
          >
            <div className="logoWrapper">
              <div className="logoContainer">
                <img
                  className={`logoOuter`}
                  src="https://d2lvj32mp5x83n.cloudfront.net/static/studentadmin/footer/background/award.png"
                  alt=""
                />
                <img
                  className={`logoInner`}
                  src="https://d2lvj32mp5x83n.cloudfront.net/static/studentadmin/footer/logo/awardLogo.png"
                  alt="trophy"
                />
               
              </div>
              <p className="mb-0 labelIcon">{t("menu.awards")}</p>
            </div>
          </Link>
        ) : (
          <Link
            to={`/student/admin/certificate-trophy`}
            className="studntFtrNavLink"
            onClick={handleLockedClick}
          >
            <div className="logoWrapper">
              <div className="logoContainer">
                <img
                  className={`logoOuter ${!isSubscribed ? "blackgrayscale" : ""}`}
                  src="https://d2lvj32mp5x83n.cloudfront.net/static/studentadmin/footer/background/award.png"
                  alt=""
                />
                <img
                  className={`logoInner ${!isSubscribed ? "blackgrayscale" : ""}`}
                  src="https://d2lvj32mp5x83n.cloudfront.net/static/studentadmin/footer/logo/awardLogo.png"
                  alt="trophy"
                />
                {!isSubscribed && (
                  <img
                    className="CommonMenuLock"
                    src="https://d2lvj32mp5x83n.cloudfront.net/static/webMap/crown.png"
                    alt=""
                  />
                )}
              </div>
              <p className="mb-0 labelIcon">{t("menu.awards")}</p>
            </div>
          </Link>
        )}
      </div>

      <AuthModal
        show={showAuthModal}
        onHide={() => setShowAuthModal(false)}
        defaultView={authModalView}
      />

      {/* NavigateToAddStudentPopup Modal */}
      <NavigateToAddStudentPopup
        showModal={showAddStudentModal}
        handleClose={() => setShowAddStudentModal(false)}
      />
    </>
  );
};
